import StatusBarButton from '../layout/StatusBarButton';

const PlantTaskNotFound = ({ onBack, displayText }) => {
  return (
    <div className="plant-task-list centered">
      <div className="plant-task-not-found-container">
        <h4>{displayText}</h4>
        <StatusBarButton
          type="inline"
          label="Back"
          icon="fas fa-chevron-left"
          reversed={false}
          statusSlot={1}
          clickHandler={onBack}
        />
      </div>
    </div>
  );
};

export default PlantTaskNotFound;
